"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableActivityTrackingWithConfig = void 0;
const activityTracking_1 = __importDefault(require("./activityTracking"));
exports.enableActivityTrackingWithConfig = activityTracking_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcGx1Z2lucy9jdXN0b21FbmFibGVDb25maWd1cmF0aW9ucy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSwwRUFBa0U7QUFFekQsMkNBRkYsMEJBQWdDLENBRUUifQ==


// WEBPACK FOOTER //
// ../../../../src/plugins/customEnableConfigurations/index.ts